import { useTranslation } from 'react-i18next'
import {
  CoverageClaimIcon,
  CoverageGrowthTrendIcon,
  CoveragePriceIcon,
} from '@/components/atoms'
import { FEATURE_ICON_CLASS } from '@/shared/constants/icons'

export function useRentersStepFivePage() {
  const { t } = useTranslation()

  const steps = [
    {
      icon: <CoveragePriceIcon className={FEATURE_ICON_CLASS} />,
      title: t('onboarding.renters.stepFive.step1Title'),
      description: t('onboarding.renters.stepFive.step1Description'),
    },
    {
      icon: <CoverageGrowthTrendIcon className={FEATURE_ICON_CLASS} />,
      title: t('onboarding.renters.stepFive.step2Title'),
      description: t('onboarding.renters.stepFive.step2Description'),
    },
    {
      icon: <CoverageClaimIcon className={FEATURE_ICON_CLASS} />,
      title: t('onboarding.renters.stepFive.step3Title'),
      description: t('onboarding.renters.stepFive.step3Description'),
    },
  ]

  return { steps }
}
